import { useSegmentedSearch } from './useSegmentedSearch';

export const useIsSegmentedWebview = () => useSegmentedSearch().isSegmentedWebview;
